<template>
  <div>
    <footer>
      <!-- FOOTER TOP -->
      <div class="ft-top">
        <div class="container">
          <div class="ft-top-wrapper">

            <div class="social">
              <template v-for="(social, key) in data.social_links">
                <a :href="social.url" :key="key" :class="social.icon" target="_blank"></a>
              </template>
            </div>

            <div class="ft-logo">
              <router-link to="/">
                <img alt="Logo" v-bind:src="data.logo_img_url">
              </router-link>
            </div>

            <div class="row justify-content-between justify-content-xl-start">
              <div class="col-md-12 ft-col" v-html="data.address_on_footer">
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="ft-bot">
        <div class="container">
          @{{ currentYear }} All Rights Reserved
        </div>
        <div class="container">
          <button v-on:click="showModal" v-if="showSetSiteHash">Switch content</button>
        </div>
      </div>
    </footer>

    <!-- CLICK TO TOP -->
    <back-to-top visibleoffset="450">
      <router-link :to="{ name: 'Checkout' }" class="fixedcheckout">
        <i class="fa fa-shopping-cart"></i>Checkout
      </router-link>
      <div class="click-to-top">
        <span class="lnr lnr-arrow-up"></span>
      </div>
    </back-to-top>

  </div>
</template>

<script>

import crypto from 'crypto'
export default {
  props: ['data'],
  data() {
    return {
      showSetSiteHash: false
    }
  },
  created() {
    if (['development', 'staging'].includes(process.env.NODE_ENV)) {
      this.showSetSiteHash = true;
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    showModal: function () {
      const site = prompt('Enter the website link')
      const shaSum = crypto.createHash('sha1')
      shaSum.update(site.replace(/\/+$/, ''))
      const hash = shaSum.digest('hex')
      localStorage.setItem('dev_site_hash', hash)
      localStorage.setItem('total_items', "0")
      localStorage.removeItem('items')
      localStorage.removeItem('cart_uuid')

      window.location.reload()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Footer.vue